
const BASE_TIME = "2021-01-01";
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject } from "@/utils";
import * as echarts from "echarts";
import {
  dispatchSimpleDateOptions,
  dispatchSimpleTypeOptions,
  dispatchSimpleDeviceOptions,
  dispatchSimpleUrl,
  dispatchSimpleData,
  dispatchNzmUploadReportImage,
  dispatchSimpleSubtypeOptions,
  dispatchSimpleSceneOptions,
  dispatchSimpleVersionOptions,
  dispatchSimpleReportOptions,
  dispatchSimpleUpdateReport,
  dispatchSimpleLabelOptions,
  dispatchSimpleTable,
  dispatchSimpleTrendParams,
  dispatchSimpleTotalTrend,
  dispatchSimpleVersionOptionsOld,
  dispatchSimpleProcessOptions,
  dispatchDeepPerformanceSimpleDetail,
  dispatchimpleThreadOptions,
  dispatchSimpleSoOptions,
  dispatchimpleLog,
  dispatchDeleteSimpleData,
} from "@/store/performance/actions";

import { store } from "@/store";
import {
  readGetSimpleDateOptions,
  readGetSimpleThreadOptions,
  readGetSimpleTypeOptions,
  readGetSimpleDeviceOptions,
  readGetSimpleVersionOptionsOld,
  readGetSimpleTotalParams,
  readGetSimpleData,
  readGetSimpleLabelOptions,
  readGetSimplSubtypeOptions,
  readGetSimpleSceneOptions,
  readGetSimpleVersionOptions,
  readGetSimpleReportOptions,
  readGetSimpleLog,
  readGetSimpleTable,
  readGetSimpleTrendParams,
  readGetSimpleUrl,
  readGetSimpleProcessOptions,
  readGetSimpleSoOptions,
} from "@/store/performance/getters"; //引入仓库接口
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects, readProjectScenes } from "@/store/project/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { ElMessage } from "element-plus";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
import { readSimpleScriptList } from "@/store/task/getters";
import { color } from "html2canvas/dist/types/css/types/color";
import { number, version } from "echarts/core";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";
import axios from 'axios'

export default class ProjectOverview extends Vue {
  is_null_arr = [false, false, false]

  async onIsNullChange(num) {
    this.tableLoding = true;
    let form: any = {};
    let tabType = "";
    tabType = this.tabType(num);
    form = this.filterListAll[num].form;

    await dispatchSimpleTable(store, {
      project: this.localProject,
      id_test: Number(form.id_test),
      Label: form.label,
      old_test: form.old_test == undefined ? 0 : Number(form.old_test),
      page: form.currentPage,
      tab: tabType,
      process_name: "",
      thread_name: "",
      so_name: "",
      size: form.size,
      search: this.serch_input,
      is_null: this.is_null_arr[num] ? 1 : 0,
    });
    this.tableData = (this.tableDataAll as any).data?.slice(
      (form.currentPage - 1) * 10,
      form.currentPage * 10
    );
    this.tableLoding = false;
  }

  public localProject = Number(getLocalProject());
  public activeName = 0;
  public loading = false;
  public show = true;
  // public  loadMore(n) {
  //     // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
  //     // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
  //     return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数  可自定义
  //   }
  public trendLoading = false;
  public serch_input = "";
  public trend_input = "";
  public tabType(item) {
    if (item == 0) {
      return "thread";
    }
    if (item === 1) {
      return "module";
    }
    if (item == 2) {
      return "so";
    }
  }
  public rangeNumber = 10;
  public tableLoding = false;
  public getHead(num) {
    if (num == "0") {
      return "线程";
    }
    if (num == "1") {
      return "函数";
    }
    if (num == "2") {
      return "so";
    }
  }
  public getWidht(num) {
    if (num == "0") {
      return "150";
    }
    if (num == "1") {
      return "500";
    }
    if (num == "2") {
      return "150";
    }
  }
  filterHospital(query) {
    if (this.activeName == 0) {
      let arr = this.SimpleTrendParams?.all_names.filter((item) => {
        return item[0].includes(query);
      });
      if (arr.length > 200) {
        this.allNames = arr.slice(0, 200);
      } else {
        this.allNames = arr;
      }
    } else {
      let arr = this.SimpleTrendParams?.all_names.filter((item) => {
        return item[0].includes(query);
      });
      if (arr.length > 200) {
        this.allNames = arr.slice(0, 200);
      } else {
        this.allNames = arr;
      }
    }
  }
  //  if (arr.length > 200) {
  //    this.HospitalListTop200 = arr.slice(0, 200);
  //  } else {
  //    this.HospitalListTop200 = arr;
  //  }

  // 排序逻辑
  public sort_change(column) {
    let form: any = {};

    this.filterListAll[this.activeName].form.currentPage = 1;

    (this.tableDataAll as any).data.sort(
      this.sortFun(column?.prop, column?.order === "ascending")
    );
    this.tableData = (this.tableDataAll as any).data?.slice(0, 10);
  }
  public sortFun(attr, rev) {
    //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
    if (rev == undefined) {
      rev = 1;
    } else {
      rev = rev ? 1 : -1;
    }
    return function (a, b) {
      a = a[attr];
      b = b[attr];
      if (a < b) {
        return rev * -1;
      }
      if (a > b) {
        return rev * 1;
      }
      return 0;
    };
  }

  public async serchChange(num) {
    this.tableLoding = true;
    let form: any = {};
    let tabType = "";
    tabType = this.tabType(num);
    form = this.filterListAll[num].form;
    form.currentpage = 1;

    await dispatchSimpleTable(store, {
      project: this.localProject,
      id_test: Number(form.id_test),
      Label: form.label,
      old_test: form.old_test == undefined ? 0 : Number(form.old_test),
      page: form.currentPage,
      tab: tabType,
      process_name: "",
      thread_name: "",
      so_name: "",
      size: form.size,
      search: this.serch_input,
      is_null: this.is_null_arr[num] ? 1 : 0,
    });
    this.tableData = (this.tableDataAll as any).data?.slice(
      (form.currentPage - 1) * 10,
      form.currentPage * 10
    );
    this.tableLoding = false;
  }
  public async tabsChange(item) {
    this.record.push(item);
    this.tableLoding = true;
    this.trendLoading = true;
    this.serch_input = "";
    this.trend_input = "";
    let form: any = {};
    let tabType = "";

    tabType = this.tabType(item);
    this.filterListAll[item].form = this.filterListAll[
      this.record[this.record.length - 2]
    ].form;
    form = this.filterListAll[item].form;

    this.filterListAll[item].form.currentPage = 1;
    this.filterListAll[item].form.valueTime = [];
    this.$router.push({
      query: {
        ...this.$route.query,
        type: this.activeName,
      },
    });
    // await dispatchSimpleDateOptions(store, {
    //   project: this.localProject,
    // });
    // form.date = readGetSimpleDateOptions(store)[0]?.date;
    // form.date1 = readGetSimpleDateOptions(store)[1]?.date;
    // await dispatchSimpleTypeOptions(store, {
    //   project: this.localProject,
    //   date: this.dateOptions.length > 0 ? form.date : "",
    // });
    // form.type = readGetSimpleTypeOptions(store)[0]?.report_type;

    // await dispatchSimpleSubtypeOptions(store, {
    //   project: this.localProject,
    //   date: this.dateOptions.length > 0 ? form.date : "",
    //   report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
    // });
    // form.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
    // await dispatchSimpleSceneOptions(store, {
    //   project: this.localProject,
    //   date: this.dateOptions.length > 0 ? form.date : "",
    //   report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
    //   subtype: Number(form.subtype),
    // });
    // form.scene = readGetSimpleSceneOptions(store)[0].scene_id;
    // await dispatchSimpleDeviceOptions(store, {
    //   project: this.localProject,
    //   date: this.dateOptions.length > 0 ? form.date : "",
    //   report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
    //   subtype: Number(form.subtype),
    //   scene_id: Number(form.scene),
    // });
    // form.uuid = readGetSimpleDeviceOptions(store)[0].UUID;
    // await dispatchSimpleVersionOptions(store, {
    //   project: this.localProject,
    //   date: this.dateOptions.length > 0 ? form.date : "",
    //   report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
    //   UUID: form.uuid,
    //   subtype: Number(form.subtype),
    //   scene_id: Number(form.scene),
    // });
    // await dispatchSimpleVersionOptionsOld(store, {
    //   project: this.localProject,
    //   date: this.dateOptions.length > 0 ? form.date1 : "",
    //   // report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
    //   // UUID: form.uuid,
    //   // subtype: Number(form.subtype),
    //   // scene_id: Number(form.scene),
    // });
    // form.id_test = readGetSimpleVersionOptions(store)[0].id_test;

    // form.old_test = readGetSimpleVersionOptionsOld(store)[0]?.id_test;
    // await dispatchSimpleLabelOptions(store, {
    //   project: this.localProject,
    //   id_test: Number(form.id_test),
    // });
    // form.label = readGetSimpleLabelOptions(store)[0]?.Label;
    await dispatchSimpleProcessOptions(store, {
      project: this.localProject,
      id_test: Number(form.id_test),
      Label: form.label,
      tab: tabType,
    });
    form.size = 10;
    if (readGetSimpleVersionOptions(store).length > 0) {
      dispatchSimpleTable(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        old_test: form.old_test == undefined ? 0 : Number(form.old_test),
        page: form.currentPage,
        tab: tabType,
        process_name: "",
        thread_name: "",
        so_name: "",
        size: form.size,
        search: this.serch_input,
        is_null: this.is_null_arr[item] ? 1 : 0,
      }).then((res) => {
        this.tableData = (this.tableDataAll as any).data?.slice(
          (form.currentPage - 1) * 10,
          form.currentPage * 10
        );
        this.tableLoding = false;
      });

      await dispatchSimpleTrendParams(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        tab: tabType,
      });
      this.newNames = [];
      if (item == 0) {
        // form.params = readGetSimpleTrendParams(store).names.map((v) => v[0]);
        form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[0]);
        this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
        this.SimpleTrendParams?.all_names?.forEach((v) => {
          form.inParms.forEach((i) => {
            if (v[0] == i) {
              this.newNames.push(v);
            }
          });
        });
      } else {
        // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
        form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[1]);
        this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
        this.SimpleTrendParams?.all_names?.forEach((v) => {
          form.inParms.forEach((i) => {
            if (v[1] == i) {
              this.newNames.push(v);
            }
          });
        });
      }
      // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
      form.uuid1 = readGetSimpleDeviceOptions(store)[0].UUID;
      let start = "";
      let end = "";
      end = readGetSimpleDateOptions(store)[0].date;
      if (readGetSimpleDateOptions(store).length > 7) {
        start = readGetSimpleDateOptions(store)[6].date;
      } else {
        start = readGetSimpleDateOptions(store)[
          readGetSimpleDateOptions(store).length - 1
        ].date;
      }
      await dispatchSimpleTotalTrend(store, {
        project: this.localProject,
        Label: form.label,
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        UUID: form.uuid1,
        subtype: Number(form.subtype),
        scene_id: Number(form.scene),
        start: start,
        end: end,
        params: Array.from(new Set(form.inParms)),
        tab: tabType,
      });
      this.show = false;
      this.show = true;
      await this.$nextTick(() => {
        this.drawpercentage(item);
        this.drawms(item);
        this.draw_ms(item);
      });
      this.trendLoading = false;
    }
  }
  public input = "";

  

  public async date(num, item, check) {
    let form: any = {};
    let tabType = "";

    tabType = this.tabType(num);
    form = this.filterListAll[num].form;

    for (let v of item) {
      if (item.length === 0 && check == true) {
        this.trendLoading = false;
      } else {
        this.trendLoading = true;
      }
      if (v === "date") {
        await dispatchSimpleTypeOptions(store, {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date : "",
        });
        // console.log(readGetSimpleTypeOptions(store))
        form.type = readGetSimpleTypeOptions(store)[0].report_type;
      }
      if (v === "type") {
        await dispatchSimpleSubtypeOptions(store, {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date : "",
          report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        });
        form.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      }
      if (v === "subtype") {
        await dispatchSimpleSceneOptions(store, {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date : "",
          report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
          subtype: Number(form.subtype),
        });
        form.scene = readGetSimpleSceneOptions(store)[0].scene_id;
      }
      if (v === "scene") {
        await dispatchSimpleDeviceOptions(store, {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date : "",
          report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
          subtype: Number(form.subtype),
          scene_id: Number(form.scene),
        });

        form.uuid = (readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0])?.UUID;
      }
      if (v === "UUID") {
        await dispatchSimpleVersionOptions(store, {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date : "",
          report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
          UUID: form.uuid,
          subtype: Number(form.subtype),
          scene_id: Number(form.scene),
        });
        form.id_test = readGetSimpleVersionOptions(store)[0].id_test;
      }
      if (v === "old_test") {
        await dispatchSimpleVersionOptionsOld(store, {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date1 : "",
          // report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
          // UUID: form.uuid,
          // subtype: Number(form.subtype),
          // scene_id: Number(form.scene),
        });
        form.old_test = readGetSimpleVersionOptionsOld(store)[0]?.id_test;
      }
      if (v === "id_test") {
        await dispatchSimpleLabelOptions(store, {
          project: this.localProject,
          id_test: Number(form.id_test),
        });

        form.label = readGetSimpleLabelOptions(store)[0]?.Label;
      }
      if (v === "log") {
        await dispatchimpleLog(store, {
          project: this.localProject,
          id_test: Number(form.id_test),
          Label: form.label,
          old_test: form.old_test == undefined ? 0 : Number(form.old_test),
        });
      }
      if (v === "datePick") {

        this.serch_input = "";
        form.size = 10;
        this.filterListAll[num].form.currentPage = 1;
        if (readGetSimpleVersionOptions(store).length > 0) {
          dispatchSimpleTable(store, {
            project: this.localProject,
            id_test: Number(form.id_test),
            Label: form.label,
            old_test: form.old_test == undefined ? 0 : Number(form.old_test),
            page: this.filterListAll[num].form.currentPage,
            tab: tabType,
            process_name: "",
            thread_name: "",
            so_name: "",
            size: form.size,
            search: this.serch_input,
            is_null: this.is_null_arr[num] ? 1 : 0,
          }).then((res) => {
            this.tableData = (this.tableDataAll as any).data?.slice(
              (form.currentPage - 1) * 10,
              form.currentPage * 10
            );
            this.tableLoding = false;
          });

          await dispatchSimpleTrendParams(store, {
            project: this.localProject,
            id_test: Number(form.id_test),
            Label: form.label,
            tab: tabType,
          });

          form.uuid1 = readGetSimpleDeviceOptions(store)[0].UUID;
          let start = "";
          let end = "";
          end = readGetSimpleDateOptions(store)[0].date;
          if (readGetSimpleDateOptions(store).length > 7) {
            start = readGetSimpleDateOptions(store)[6].date;
          } else {
            start = readGetSimpleDateOptions(store)[
              readGetSimpleDateOptions(store).length - 1
            ].date;
          }
          this.newNames = [];
          if (num == 0) {
            // form.params = readGetSimpleTrendParams(store).names.map((v) => v[0]);
            form.inParms = readGetSimpleTrendParams(store).names.map(
              (v) => v[0]
            );
            this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
            this.SimpleTrendParams?.all_names?.forEach((v) => {
              form.inParms.forEach((i) => {
                if (v[0] == i) {
                  this.newNames.push(v);
                }
              });
            });
          } else {
            // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
            form.inParms = readGetSimpleTrendParams(store).names.map(
              (v) => v[1]
            );
            this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
            this.SimpleTrendParams?.all_names?.forEach((v) => {
              form.inParms.forEach((i) => {
                if (v[1] == i) {
                  this.newNames.push(v);
                }
              });
            });
          }

          await dispatchSimpleTotalTrend(store, {
            project: this.localProject,
            Label: form.label,
            report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
            UUID: form.uuid1,
            subtype: Number(form.subtype),
            scene_id: Number(form.scene),
            start: start,
            end: end,
            params: Array.from(new Set(form.inParms)),
            tab: tabType,
          });
          this.show = false;
          this.show = true;
          await this.$nextTick(() => {
            this.drawpercentage(String(num));
            this.drawms(String(num));
            this.draw_ms(String(num));
          });
        }
      }
      if (v === "dateTo") {
        await dispatchSimpleTrendParams(store, {
          project: this.localProject,
          id_test: Number(form.id_test),
          Label: form.label,
          tab: tabType,
        });
        this.newNames = [];
        if (num == 0) {
          // form.params = readGetSimpleTrendParams(store).names.map((v) => v[0]);
          form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[0]);
          this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
          this.SimpleTrendParams?.all_names?.forEach((v) => {
            form.inParms.forEach((i) => {
              if (v[0] == i) {
                this.newNames.push(v);
              }
            });
          });
        } else {
          // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
          form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[1]);
          // this.allNames = this.SimpleTrendParams?.all_names;
          // this.allNames = this.SimpleTrendParams.all_names;
          this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
          this.SimpleTrendParams?.all_names?.forEach((v) => {
            form.inParms.forEach((i) => {
              if (v[1] == i) {
                this.newNames.push(v);
              }
            });
          });
        }
        // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
        form.uuid1 = readGetSimpleDeviceOptions(store)[0].UUID;
      }
      if (v === "params1") {
        let startTimeAll = dateConversion(form.valueTime[0]);
        let endTimeAll = dateConversion(form.valueTime[1]);
        let startTime = startTimeAll.split(" ")[0];
        let endTime = endTimeAll.split(" ")[0];
        let start = "";
        let end = "";
        end = readGetSimpleDateOptions(store)[0].date;
        if (readGetSimpleDateOptions(store).length > 7) {
          start = readGetSimpleDateOptions(store)[6].date;
        } else {
          start = readGetSimpleDateOptions(store)[
            readGetSimpleDateOptions(store).length - 1
          ].date;
        }
        this.newNames = [];

        if (num == 0) {
          // form.params = readGetSimpleTrendParams(store).names.map((v) => v[0]);
          // form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[0]);
          this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
          this.SimpleTrendParams?.all_names?.forEach((v) => {
            form.inParms.forEach((i) => {
              if (v[0] == i) {
                this.newNames.push(v);
              }
            });
          });
        } else {
          // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
          // form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[1]);

          this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
          this.SimpleTrendParams?.all_names?.forEach((v) => {
            form.inParms.forEach((i) => {
              if (v[1] == i) {
                this.newNames.push(v);
              }
            });
          });
        }

        await dispatchSimpleTotalTrend(store, {
          project: this.localProject,
          Label: form.label,
          report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
          UUID: form.uuid1,
          subtype: Number(form.subtype),
          scene_id: Number(form.scene),
          start: startTime === "-" ? start : startTime,
          end: endTime === "-" ? end : endTime,
          params: Array.from(new Set(form.inParms)),
          tab: tabType,
        });
        this.show = false;
        this.show = true;
        await this.$nextTick(() => {
          this.drawpercentage(String(num));
          this.drawms(String(num));
          this.draw_ms(String(num));
        });
      }

    }
    if (check === true) {
      this.tableLoding = true;
      this.filterListAll[num].form.currentPage = 1;

      await dispatchSimpleTable(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        old_test: form.old_test == undefined ? 0 : Number(form.old_test),
        page: this.filterListAll[num].form.currentPage,
        tab: tabType,
        process_name: "",
        thread_name: "",
        so_name: "",
        size: form.size,
        search: this.serch_input,
        is_null: this.is_null_arr[num] ? 1 : 0,
      });
      this.tableData = (this.tableDataAll as any).data?.slice(
        (form.currentPage - 1) * 10,
        form.currentPage * 10
      );
      this.tableLoding = false;
    }
    if (item.length === 0 && check == false) {
      let startTimeAll = dateConversion(form.valueTime[0]);
      let endTimeAll = dateConversion(form.valueTime[1]);
      let startTime = startTimeAll.split(" ")[0];
      let endTime = endTimeAll.split(" ")[0];
      let start = "";
      let end = "";
      end = readGetSimpleDateOptions(store)[0].date;
      if (readGetSimpleDateOptions(store).length > 7) {
        start = readGetSimpleDateOptions(store)[6].date;
      } else {
        start = readGetSimpleDateOptions(store)[
          readGetSimpleDateOptions(store).length - 1
        ].date;
      }
      await dispatchSimpleTotalTrend(store, {
        project: this.localProject,
        Label: form.label,
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        UUID: form.uuid1,
        subtype: Number(form.subtype),
        scene_id: Number(form.scene),
        start: startTime === "-" ? start : startTime,
        end: endTime === "-" ? end : endTime,
        params: Array.from(new Set(form.inParms)),
        tab: tabType,
      });
      this.show = false;
      this.show = true;
      await this.$nextTick(() => {
        this.drawpercentage(String(num));
        this.drawms(String(num));
        this.draw_ms(String(num));
      });
    }

    this.trendLoading = false;
  }

  public onSearch(num) {
    let form: any = {};
    let tabType = "";

    tabType = this.tabType(num);
    form = this.filterListAll[num].form;
    this.tableData = (this.tableDataAll as any).data?.slice(
      (form.currentPage - 1) * 10,
      form.currentPage * 10
    );
  }

  public drawpercentage(i) {
    let series: any[] = [];

    (this.SimpleTrendTotal as any).params?.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.SimpleTrendTotal as any).rate[index],
      });
    });

    let performance_line: any = document.getElementById(
      "percentage" + String(i)
    );
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      title: {
        left: "center",

        text: "日稳定包函数耗时趋势图(百分比)",
      },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: (this.SimpleTrendTotal as any).date,
      },

      series: series,
    });
  }
  public drawms(i) {
    let series: any[] = [];

    (this.SimpleTrendTotal as any).params.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.SimpleTrendTotal as any).ms[index],
      });
    });

    let performance_line: any = document.getElementById(
      "EventCount" + String(i)
    );
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      title: {
        left: "center",

        // text: "日稳定包函数耗时趋势图(ms)",
        text: "日稳定包函数EventCount趋势图",
      },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: (this.SimpleTrendTotal as any).date,
      },

      series: series,
    });
  }
  public draw_ms(i) {
    let series: any[] = [];

    (this.SimpleTrendTotal as any).params.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.SimpleTrendTotal as any).real_ms[index],
      });
    });

    let performance_line: any = document.getElementById("ms" + String(i));
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      title: {
        left: "center",

        text: "日稳定包函数耗时趋势图(ms)",
        // text: "日稳定包函数EventCount趋势图",
      },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: (this.SimpleTrendTotal as any).date,
      },

      series: series,
    });
  }
  public tableData = [];
  public filterListAll = [
    {
      name: "线程消耗",
      form: {
        date: "",
        type: "",
        subtype: "",
        scene: "",
        uuid: "",
        id_test: "",
        label: "",
        old_test: "",
        currentPage: 1,
        valueTime: [],
        process: "",
        size: 20,
        size1: 10,
        params: "",
        inParms: [],
        uuid1: "",
        date1: "",
        is_null: false,
      },
    },
    {
      name: "函数消耗",
      form: {
        date: "",
        type: "",
        subtype: "",
        thread_name: "",
        so_name: "",
        size: 10,
        size1: 10,
        scene: "",
        uuid: "",
        id_test: "",
        label: "",
        old_test: "",
        currentPage: 1,
        valueTime: [],
        process: "",
        params: "",
        inParms: [],
        uuid1: "",
        date1: "",
        is_null: false,
      },
    },
    {
      name: "so消耗",
      form: {
        date: "",
        type: "",
        thread_name: "",
        process: "",
        subtype: "",
        scene: "",
        uuid: "",
        id_test: "",
        label: "",
        old_test: "",
        size: 10,
        size1: 10,
        currentPage: 1,
        valueTime: [],
        params: "",
        inParms: [],
        uuid1: "",
        date1: "",
        is_null: false,
      },
    },
  ];
  public filterList = {
    date: "",
    type: "",
    subtype: "",
    scene: "",
    uuid: "",
    id_test: "",
    label: "",
    old_test: "",
    currentPage: 1,
  };
  public filterList2 = {
    date: "",
    type: "",
    subtype: "",
    scene: "",
    uuid: "",
    id_test: "",
    label: "",
    old_test: "",
    currentPage: 1,
  };
  public filterList3 = {
    date: "",
    type: "",
    subtype: "",
    scene: "",
    uuid: "",
    id_test: "",
    label: "",
    old_test: "",
    currentPage: 1,
  };
  public packageBtn() {
    if (this.simpleUrl === "") {
      ElMessage.error("无对应的流水线");
    } else {
      window.open(this.simpleUrl, "_blank");
    }
  }
  public dateList = [];
  public typeList = [];
  public deviceList = [];
  public subtypeList = [];
  public sceneList = [];
  public trendList = { names: [], all_names: [] };
  public trendTotal = {};
  public versionList = [];
  public versionListOld = [];
  public labelList = [];
  public processList = {};
  public threadList = {};
  public soList = {};
  public sizeList = [];
  public tableDataList = {};
  public tableDataLog = {};
  public reportList = [];
  public get dateOptions() {
    this.dateList = readGetSimpleDateOptions(store);
    return this.dateList;
  }
  public get typeOptions() {
    this.typeList = readGetSimpleTypeOptions(store);
    return this.typeList;
  }
  public get deviceOptions() {
    this.deviceList = readGetSimpleDeviceOptions(store);
    return this.deviceList;
  }
  public get subtypeOptions() {
    this.subtypeList = readGetSimplSubtypeOptions(store);
    return this.subtypeList;
  }
  public get sceneOptions() {
    this.sceneList = readGetSimpleSceneOptions(store);
    return this.sceneList;
  }
  public logName = "";
  public dialogFormVisible1 = false;
  public editBtn(i) {
    this.logName = this.versionOptions.filter(
      (v) => v.id_test == i
    )[0].game_version;
    this.dialogFormVisible1 = true;
  }
  public get SimpleTrendParams() {
    if (this.activeName != 0) {
      this.trendList = readGetSimpleTrendParams(store);
    } else {
      this.trendList.all_names = [];
      readGetSimpleTrendParams(store)?.all_names;
      for (
        let i = 0;
        i < readGetSimpleTrendParams(store)?.all_names?.length;
        i++
      ) {
        // 设置一个开关，如果是true，就存进去，不是就不存
        let flag = true;
        for (let j = 0; j < this.trendList.all_names?.length; j++) {
          // 原数组和新数组作比较，如果一致，开关变为 false
          readGetSimpleTrendParams(store)?.all_names[i][0] ===
          this.trendList.all_names[j][0]
            ? (flag = false)
            : flag;
        }
        flag
          ? this.trendList.all_names.push(
              readGetSimpleTrendParams(store)?.all_names[i]
            )
          : readGetSimpleTrendParams(store)?.all_names;
      }
    }

    return this.trendList;
  }
  public get SimpleTrendTotal() {
    this.trendTotal = readGetSimpleTotalParams(store);
    return this.trendTotal;
  }
  // public async timeChange(item) {
  //     let startTimeAll = dateConversion(item[0]);
  //     let endTimeAll = dateConversion(item[1]);
  //     let startTime = startTimeAll.split(" ")[0];
  //     let endTime = endTimeAll.split(" ")[0];
  //     console.log(startTime,endTime)
  // }

  public get versionOptions() {
    this.versionList = readGetSimpleVersionOptions(store);

    return this.versionList;
  }
  // public get versionOptionsOld() {
  //   this.versionListOld = readGetSimpleVersionOptionsOld(store);

  //   return this.versionListOld;
  // }
  public get processOptions() {
    this.processList = readGetSimpleProcessOptions(store);

    return this.processList;
  }
  public get threadOptions() {
    this.threadList = readGetSimpleThreadOptions(store);

    return this.threadList;
  }
  public get soOptions() {
    this.soList = readGetSimpleSoOptions(store);

    return this.soList;
  }
  public get sizeOptions() {
    this.sizeList = [10, 20, 30, "All"];

    return this.sizeList;
  }
  public async dialogFormVisible2(num, i) {
    this.dialogFormVisible1 = false;
    let form: any = {};
    let tabType = "";

    tabType = this.tabType(num);
    form = this.filterListAll[num].form;
    await dispatchDeepPerformanceSimpleDetail(store, {
      project: this.localProject,
      id_test: i,
      name: this.logName,
    });
    await dispatchSimpleVersionOptions(store, {
      project: this.localProject,
      date: this.dateOptions.length > 0 ? form.date : "",
      report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
      UUID: form.uuid,
      subtype: Number(form.subtype),
      scene_id: Number(form.scene),
    });
  }
  public getDay(day: any) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  }
  public doHandleMonth(month: any) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  }

  public com_num(oldvAlue, newValue, type) {
    if (newValue === "") {
      return "--";
    }
    oldvAlue = Number(oldvAlue);
    newValue = Number(newValue);
    if (type === "rate") {
      if (oldvAlue > newValue) {
        return (oldvAlue - newValue).toFixed(2) + "↑";
      }
      if (newValue > oldvAlue) {
        return (newValue - oldvAlue).toFixed(2) + "↓";
      }
      if (newValue === oldvAlue) {
        return "0";
      }
    }
    if (type === "ms") {
      if (oldvAlue > newValue) {
        return oldvAlue - newValue + "↑";
      }
      if (newValue > oldvAlue) {
        return newValue - oldvAlue + "↓";
      }
      if (newValue === oldvAlue) {
        return "0";
      }
    }
  }
  public get simpleUrl() {
    return readGetSimpleUrl(store);
  }
  public com_num_color(item) {
    if (item.indexOf("↑") != -1) {
      return "red";
    } else if (item.indexOf("↓") != -1) {
      return "#00b050";
    } else {
      return "#212529";
    }
  }
  public start_date = this.getDay(-6);
  public end_date = this.getDay(0);
  public get labelOptions() {
    this.labelList = readGetSimpleLabelOptions(store);
    return this.labelList;
  }
  public get tableDataAll() {
    this.tableDataList = readGetSimpleTable(store);
    return this.tableDataList;
  }
  public get tableLog() {
    this.tableDataLog = readGetSimpleLog(store);
    return this.tableDataLog;
  }

  /* 对比功能 */
    oldTypeOptions = []
    oldSubTypeOptions = []
    oldSceneOptions = []
    oldDeviceOptions = []
    versionOptionsOld = []
    oldLabelOptions = []

    async getOldTypeOption(form) {
      const {data} = await axios('deep_performance/simple_type_options/', {
        params: {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date1 : "",
        }
      })
      this.oldTypeOptions = data
      form.old_type = data[0]?.report_type
    }

    async getOldSubTypeOption(form) {
      const {data} = await axios('deep_performance/simple_subtype_options/', {
        params: {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date1 : "",
          report_type: this.oldTypeOptions.length > 0 ? Number(form.old_type) : "",
        }
      })
      this.oldSubTypeOptions = data
      form.old_subtype = data[0]?.subtype
    }

    async getOldSceneOption(form) {
      const {data} = await axios('deep_performance/simple_scene_options/', {
        params: {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date1 : "",
          report_type: this.oldTypeOptions.length > 0 ? Number(form.old_type) : "",
          subtype: Number(form.old_subtype),
        }
      })
      this.oldSceneOptions = data
      form.old_scene = data[0]?.scene_id
    }

    async getOldDeviceOption(form) {
      const {data} = await axios('deep_performance/simple_device_options/', {
        params: {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date1 : "",
          report_type: this.oldTypeOptions.length > 0 ? Number(form.old_type) : "",
          subtype: Number(form.old_subtype),
          scene_id: Number(form.old_scene),
        }
      })
      this.oldDeviceOptions = data

      const option = data.find(item => item.name.includes('J200')) || data[0]
      form.old_uuid = option?.UUID
    }

    async getOldVersionOption(form) {
      const {data} = await axios('deep_performance/simple_version_options/', {
        params: {
          project: this.localProject,
          date: this.dateOptions.length > 0 ? form.date1 : "",
          report_type: this.oldTypeOptions.length > 0 ? Number(form.old_type) : "",
          subtype: Number(form.old_subtype),
          scene_id: Number(form.old_scene),
          UUID: form.old_uuid
        }
      })
      this.versionOptionsOld = data
      form.old_test = data[0]?.id_test
    }

    async getOldLabelOption(form) {
      const {data} = await axios('deep_performance/simple_label_options/', {
        params: {
          project: this.localProject,
          id_test: Number(form.old_test),
        }
      })
      this.oldLabelOptions = data
      form.old_label = data[0]?.Label
    }

    async getOldOption(form) {
      await this.getOldTypeOption(form)
      await this.getOldSubTypeOption(form)
      await this.getOldSceneOption(form)
      await this.getOldDeviceOption(form)
      await this.getOldVersionOption(form)
      //this.getOldLabelOption(form)
    }
  /**/

  /*对比选项变化*/
    async getSimpleTable(index, form, tabType) {
      this.filterListAll[index].form.currentPage = 1;

      await dispatchSimpleTable(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        old_test: form.old_test == undefined ? 0 : Number(form.old_test),
        page: this.filterListAll[index].form.currentPage,
        tab: tabType,
        process_name: "",
        thread_name: "",
        so_name: "",
        size: form.size,
        search: this.serch_input,
        is_null: this.is_null_arr[index] ? 1 : 0,
      });
      this.tableData = (this.tableDataAll as any).data?.slice(
        (form.currentPage - 1) * 10,
        form.currentPage * 10
      );
    }

    async onOldDateChange(index) {
      const form = this.filterListAll[index].form
      await this.getOldOption(form)
    }

    async onOldTypeChange(index) {
      const form = this.filterListAll[index].form

      await this.getOldSubTypeOption(form)
      await this.getOldSceneOption(form)
      await this.getOldDeviceOption(form)
      await this.getOldVersionOption(form)
    }
    
    async onOldSubTypeChange(index) {
      const form = this.filterListAll[index].form

      await this.getOldSceneOption(form)
      await this.getOldDeviceOption(form)
      await this.getOldVersionOption(form)
    }

    async onOldSceneChange(index) {
      const form = this.filterListAll[index].form

      await this.getOldDeviceOption(form)
      await this.getOldVersionOption(form)
    }

    async onOldDeviceChange(index) {
      const form = this.filterListAll[index].form

      await this.getOldVersionOption(form)
    }

    async onOldVersionChange(index) {
      // 仅切换版本，不刷新表格数据
    }

    /* 查询按钮：点击后加载页面数据（表格/趋势图/火焰图/安装包链接） */
    async onQueryClick(index) {
      const form = this.filterListAll[index].form
      if (!form.id_test) {
        return
      }
      // 安装包链接
      await dispatchSimpleUrl(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
      })
      // 表格 + 趋势图 + 图表、火焰图
      await this.date(index, ['datePick', 'log'], false)
    }
  /**/

  public record = [];
  public async mounted() {
    // this.loading = true;
    this.tableLoding = true;
    this.trendLoading = true;
    if (this.$route.query.type) {
      let form: any = {};
      let tabType = "";
      this.activeName = Number(this.$route.query.type);
      let item = Number(this.$route.query.type);
      this.record.push(item);
      tabType = this.tabType(item);
      form = this.filterListAll[item].form;
      this.filterListAll[item].form.currentPage = 1;
      this.filterListAll[item].form.valueTime = [];
      await dispatchSimpleDateOptions(store, {
        project: this.localProject,
      });
      form.date = readGetSimpleDateOptions(store)[0].date;
      form.date1 = readGetSimpleDateOptions(store)[1].date;
      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
      });
      form.type = readGetSimpleTypeOptions(store)[0]?.report_type;

      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
      });
      form.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        subtype: Number(form.subtype),
      });
      form.scene = readGetSimpleSceneOptions(store)[0].scene_id;
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        subtype: Number(form.subtype),
        scene_id: Number(form.scene),
      });

      const option = readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0]
      form.uuid = option?.UUID;

      await dispatchSimpleVersionOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        UUID: form.uuid,
        subtype: Number(form.subtype),
        scene_id: Number(form.scene),
      });
     
      form.id_test = readGetSimpleVersionOptions(store)[0].id_test;

      
      await dispatchSimpleLabelOptions(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
      });
      form.label = readGetSimpleLabelOptions(store)[0]?.Label;
      await dispatchSimpleUrl(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
      });
      form.size = 10;

      await this.getOldOption(form)

      await dispatchimpleLog(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        old_test: form.old_test == undefined ? 0 : Number(form.old_test),
      });
      if (readGetSimpleVersionOptions(store).length > 0) {
        dispatchSimpleTable(store, {
          project: this.localProject,
          id_test: Number(form.id_test),
          Label: form.label,
          old_test: form.old_test == undefined ? 0 : Number(form.old_test),
          page: form.currentPage,
          tab: tabType,
          process_name: "",
          thread_name: "",
          so_name: "",
          size: form.size,
          search: this.serch_input,
          is_null: this.is_null_arr[item] ? 1 : 0
        }).then((res) => {
          this.tableData = (this.tableDataAll as any).data?.slice(
            (form.currentPage - 1) * 10,
            form.currentPage * 10
          );
          this.tableLoding = false;
        });

        await dispatchSimpleTrendParams(store, {
          project: this.localProject,
          id_test: Number(form.id_test),
          Label: form.label,
          tab: tabType,
        });

        this.newNames = [];
        if (item == 0) {
          // form.params = readGetSimpleTrendParams(store).names.map((v) => v[0]);
          form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[0]);
          this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
          this.SimpleTrendParams?.all_names?.forEach((v) => {
            form.inParms.forEach((i) => {
              if (v[0] == i) {
                this.newNames.push(v);
              }
            });
          });
        } else {
          // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
          form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[1]);
          this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);

          this.SimpleTrendParams?.all_names?.forEach((v) => {
            form.inParms.forEach((i) => {
              if (v[1] == i) {
                this.newNames.push(v);
              }
            });
          });
        }

        // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
        const option = readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0]
        form.uuid1 = option?.UUID;
        let start = "";
        let end = "";
        end = readGetSimpleDateOptions(store)[0].date;
        if (readGetSimpleDateOptions(store).length > 7) {
          start = readGetSimpleDateOptions(store)[6].date;
        } else {
          start = readGetSimpleDateOptions(store)[
            readGetSimpleDateOptions(store).length - 1
          ].date;
        }

        await dispatchSimpleTotalTrend(store, {
          project: this.localProject,
          Label: form.label,
          report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
          UUID: form.uuid1,
          subtype: Number(form.subtype),
          scene_id: Number(form.scene),
          start: start,
          end: end,
          params: Array.from(new Set(form.inParms)),
          tab: tabType,
        });
        this.show = false;
        this.show = true;
        await this.$nextTick(() => {
          this.drawpercentage(item);
          this.drawms(item);
          this.draw_ms(item);
        });
        this.trendLoading = false;
      }
    } else {
      this.$router.push({
        query: {
          ...this.$route.query,
          type: this.activeName,
        },
      });
      this.record.push(0);
      await dispatchSimpleDateOptions(store, {
        project: this.localProject,
      });
      this.filterListAll[0].form.date = readGetSimpleDateOptions(store)[0].date;
      this.filterListAll[0].form.date1 = readGetSimpleDateOptions(
        store
      )[1].date;
      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date:
          this.dateOptions.length > 0 ? this.filterListAll[0].form.date : "",
      });
      this.filterListAll[0].form.type = readGetSimpleTypeOptions(
        store
      )[0]?.report_type;
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date:
          this.dateOptions.length > 0 ? this.filterListAll[0].form.date : "",
        report_type:
          this.typeOptions.length > 0
            ? Number(this.filterListAll[0].form.type)
            : "",
      });
      this.filterListAll[0].form.subtype = readGetSimplSubtypeOptions(
        store
      )[0].subtype;
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date:
          this.dateOptions.length > 0 ? this.filterListAll[0].form.date : "",
        report_type:
          this.typeOptions.length > 0
            ? Number(this.filterListAll[0].form.type)
            : "",
        subtype: Number(this.filterListAll[0].form.subtype),
      });
      this.filterListAll[0].form.scene = readGetSimpleSceneOptions(
        store
      )[0].scene_id;
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date:
          this.dateOptions.length > 0 ? this.filterListAll[0].form.date : "",
        report_type:
          this.typeOptions.length > 0
            ? Number(this.filterListAll[0].form.type)
            : "",
        subtype: Number(this.filterListAll[0].form.subtype),
        scene_id: Number(this.filterListAll[0].form.scene),
      });
      this.filterListAll[0].form.uuid = readGetSimpleDeviceOptions(
        store
      )[0].UUID;
      await dispatchSimpleVersionOptions(store, {
        project: this.localProject,
        date:
          this.dateOptions.length > 0 ? this.filterListAll[0].form.date : "",
        report_type:
          this.typeOptions.length > 0
            ? Number(this.filterListAll[0].form.type)
            : "",
        UUID: this.filterListAll[0].form.uuid,
        subtype: Number(this.filterListAll[0].form.subtype),
        scene_id: Number(this.filterListAll[0].form.scene),
      });
      await dispatchSimpleVersionOptionsOld(store, {
        project: this.localProject,
        date:
          this.dateOptions.length > 0 ? this.filterListAll[0].form.date1 : "",
        // report_type:
        //   this.typeOptions.length > 0
        //     ? Number(this.filterListAll[0].form.type)
        //     : "",
        // UUID: this.filterListAll[0].form.uuid,
        // subtype: Number(this.filterListAll[0].form.subtype),
        // scene_id: Number(this.filterListAll[0].form.scene),
      });
      this.filterListAll[0].form.id_test = readGetSimpleVersionOptions(
        store
      )[0].id_test;

      this.filterListAll[0].form.old_test = readGetSimpleVersionOptionsOld(
        store
      )[0]?.id_test;

      await dispatchSimpleLabelOptions(store, {
        project: this.localProject,
        id_test: Number(this.filterListAll[0].form.id_test),
      });
      this.filterListAll[0].form.label = readGetSimpleLabelOptions(
        store
      )[0].Label;
      await dispatchSimpleUrl(store, {
        project: this.localProject,
        id_test: Number(this.filterListAll[0].form.id_test),
      });
      await dispatchSimpleProcessOptions(store, {
        project: this.localProject,
        id_test: Number(this.filterListAll[0].form.id_test),
        Label: this.filterListAll[0].form.label,
        tab: "thread",
      });

      this.filterListAll[0].form.process = Object.keys(
        readGetSimpleProcessOptions(store)
      )[0];
      // await dispatchimpleThreadOptions(store,{
      //        project:this.localProject,
      //   id_test:Number(this.filterListAll[0].form.id_test),
      //   Label:this.filterListAll[0].form.label,
      //   tab:'thread',
      //   process_name: this.filterListAll[0].form.process
      // })
      this.filterListAll[0].form.size = 20;

      await dispatchimpleLog(store, {
        project: this.localProject,
        id_test: Number(this.filterListAll[0].form.id_test),
        Label: this.filterListAll[0].form.label,
        old_test:
          this.filterListAll[0].form.old_test == undefined
            ? 0
            : Number(this.filterListAll[0].form.old_test),
      });
      if (readGetSimpleVersionOptions(store).length > 0) {
        dispatchSimpleTable(store, {
          project: this.localProject,
          id_test: Number(this.filterListAll[0].form.id_test),
          Label: this.filterListAll[0].form.label,
          old_test:
            this.filterListAll[0].form.old_test == undefined
              ? 0
              : Number(this.filterListAll[0].form.old_test),
          page: this.filterListAll[0].form.currentPage,
          tab: "thread",
          process_name: "",
          thread_name: "",
          so_name: "",
          size: this.filterListAll[0].form.size,
          search: this.serch_input,
          is_null: this.is_null_arr[0] ? 1 : 0,
        }).then((res) => {
          this.tableData = (this.tableDataAll as any).data?.slice(
            (this.filterListAll[0].form.currentPage - 1) * 10,
            this.filterListAll[0].form.currentPage * 10
          );
          this.tableLoding = false;
        });

        await dispatchSimpleTrendParams(store, {
          project: this.localProject,
          id_test: Number(this.filterListAll[0].form.id_test),
          Label: this.filterListAll[0].form.label,

          tab: "thread",
        });
        this.filterListAll[0].form.inParms = readGetSimpleTrendParams(
          store
        ).names.map((v) => v[0]);
        this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
        this.SimpleTrendParams?.all_names?.forEach((v) => {
          this.filterListAll[0].form.inParms.forEach((i) => {
            if (v[0] == i) {
              this.newNames.push(v);
            }
          });
        });
        
        const option = readGetSimpleDeviceOptions(store).find(item => item.name.includes('J200')) || readGetSimpleDeviceOptions(store)[0]
        this.filterListAll[0].form.uuid1 = option?.UUID;

        let start = "";
        let end = "";
        end = readGetSimpleDateOptions(store)[0].date;
        if (readGetSimpleDateOptions(store).length > 7) {
          start = readGetSimpleDateOptions(store)[6].date;
        } else {
          start = readGetSimpleDateOptions(store)[
            readGetSimpleDateOptions(store).length - 1
          ].date;
        }
        await dispatchSimpleTotalTrend(store, {
          project: this.localProject,
          Label: this.filterListAll[0].form.label,
          report_type:
            this.typeOptions.length > 0
              ? Number(this.filterListAll[0].form.type)
              : "",
          UUID: this.filterListAll[0].form.uuid1,
          subtype: Number(this.filterListAll[0].form.subtype),
          scene_id: Number(this.filterListAll[0].form.scene),
          start: start,
          end: end,
          params: Array.from(new Set(this.filterListAll[0].form.inParms)),
          tab: "thread",
        });

        //     this.filterListAll[0].form.valueTime=[new Date(d.getFullYear(), d.getMonth(), d.getDate(), ),
        // new Date(d.getFullYear(), d.getMonth(), 11,),]

        // this.$router.push({
        //   query: {
        //     ...this.$route.query,
        //     date: this.filterList.date,
        //     report_type: Number(this.filterList.type),
        //     subtype: Number(this.filterList.subtype),
        //     scene_id:this.filterList.scene,
        //     UUID: this.filterList.uuid,

        //   },
        // });
        await this.$nextTick(() => {
          this.drawpercentage("0");
          this.drawms("0");
          this.draw_ms("0");
        });
      }
      this.trendLoading = false;
    }
  }
  public trendChange() {
    if (this.trend_input == "") {
      this.allNames = this.SimpleTrendParams.all_names;
    } else {
      this.allNames = [];
      this.SimpleTrendParams.all_names.forEach((v) => {
        if (this.activeName == 0) {
          if (v[0].includes(this.trend_input) == true) {
            this.allNames.push(v);
          }
        } else {
          if (v[1].includes(this.trend_input) == true) {
            this.allNames.push(v);
          }
        }
      });
    }
  }
  public allNames = [];
  public newNames = [];
  public async deleteData(item) {
    let form: any = {};
    let tabType = "";
    this.serch_input = "";
    this.trend_input = "";
    tabType = this.tabType(item);
    form = this.filterListAll[item].form;
    this.filterListAll[item].form.currentPage = 1;
    this.filterListAll[item].form.valueTime = [];
    let num = 0;
    if (this.versionOptions.length > 1) {
      this.versionOptions.forEach((v, index) => {
        if (v.id_test == this.filterListAll[item].form.id_test) {
          num = index;
        }
      });
      this.versionOptions.splice(num, 1);
      dispatchDeleteSimpleData(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
      });
      form.id_test = this.versionOptions[0].id_test;
      this.date(
        item,
        ["id_test", "datePick", "process", "thread", "so", "old_test"],
        true
      );
    } else {
      await dispatchDeleteSimpleData(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
      });
      await dispatchSimpleDateOptions(store, {
        project: this.localProject,
      });
      form.date = readGetSimpleDateOptions(store)[0].date;
      form.date1 = readGetSimpleDateOptions(store)[1].date;
      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
      });
      form.type = readGetSimpleTypeOptions(store)[0]?.report_type;

      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
      });
      form.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      await dispatchSimpleSceneOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        subtype: Number(form.subtype),
      });
      form.scene = readGetSimpleSceneOptions(store)[0].scene_id;
      await dispatchSimpleDeviceOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        subtype: Number(form.subtype),
        scene_id: Number(form.scene),
      });
      form.uuid = readGetSimpleDeviceOptions(store)[0].UUID;
      await dispatchSimpleVersionOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date : "",
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        UUID: form.uuid,
        subtype: Number(form.subtype),
        scene_id: Number(form.scene),
      });
      await dispatchSimpleVersionOptionsOld(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? form.date1 : "",
        // report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        // UUID: form.uuid,
        // subtype: Number(form.subtype),
        // scene_id: Number(form.scene),
      });
      form.id_test = readGetSimpleVersionOptions(store)[0]?.id_test;

      form.old_test = readGetSimpleVersionOptionsOld(store)[0]?.id_test;
      await dispatchSimpleLabelOptions(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
      });
      form.label = readGetSimpleLabelOptions(store)[0]?.Label;
      await dispatchSimpleUrl(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
      });
      form.size = 10;

      await dispatchimpleLog(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        old_test: form.old_test == undefined ? 0 : Number(form.old_test),
      });

      await dispatchSimpleTable(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        old_test: form.old_test == undefined ? 0 : Number(form.old_test),
        page: form.currentPage,
        tab: tabType,
        process_name: "",
        thread_name: "",
        so_name: "",
        size: form.size,
        search: this.serch_input,
        is_null: this.is_null_arr[item] ? 1 : 0,
      });
      this.tableData = (this.tableDataAll as any).data?.slice(
        (form.currentPage - 1) * 10,
        form.currentPage * 10
      );
      this.tableLoding = false;
      await dispatchSimpleTrendParams(store, {
        project: this.localProject,
        id_test: Number(form.id_test),
        Label: form.label,
        tab: tabType,
      });
      this.newNames = [];
      if (item == 0) {
        // form.params = readGetSimpleTrendParams(store).names.map((v) => v[0]);
        form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[0]);
        this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);
        this.SimpleTrendParams?.all_names?.forEach((v) => {
          form.inParms.forEach((i) => {
            if (v[0] == i) {
              this.newNames.push(v);
            }
          });
        });
      } else {
        // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
        form.inParms = readGetSimpleTrendParams(store).names.map((v) => v[1]);
        this.allNames = this.SimpleTrendParams?.all_names.slice(0, 200);

        this.SimpleTrendParams?.all_names?.forEach((v) => {
          form.inParms.forEach((i) => {
            if (v[1] == i) {
              this.newNames.push(v);
            }
          });
        });
      }

      // form.params = readGetSimpleTrendParams(store).names.map((v) => v[1]);
      form.uuid1 = readGetSimpleDeviceOptions(store)[0].UUID;
      let start = "";
      let end = "";
      end = readGetSimpleDateOptions(store)[0].date;
      if (readGetSimpleDateOptions(store).length > 7) {
        start = readGetSimpleDateOptions(store)[6].date;
      } else {
        start = readGetSimpleDateOptions(store)[
          readGetSimpleDateOptions(store).length - 1
        ].date;
      }

      await dispatchSimpleTotalTrend(store, {
        project: this.localProject,
        Label: form.label,
        report_type: this.typeOptions.length > 0 ? Number(form.type) : "",
        UUID: form.uuid1,
        subtype: Number(form.subtype),
        scene_id: Number(form.scene),
        start: start,
        end: end,
        params: Array.from(new Set(form.inParms)),
        tab: tabType,
      });
      this.show = false;
      this.show = true;
      await this.$nextTick(() => {
        this.drawpercentage(item);
        this.drawms(item);
        this.draw_ms(item);
      });
      this.trendLoading = false;
    }
  }
  public exportExcel(item) {
    //  .table要导出的是哪一个表格
    //  .table要导出的是哪一个表格
    this.tableLoding = true;
    let form: any = {};
    form = this.filterListAll[item].form;
    // form.size1=(this.tableDataAll as any).data.length
    form.currentPage = 1;
    // let num=1
    // let num1=0;
    // let maxPage=100
    // //  form.size1=maxPage
    // let max=Math.ceil((this.tableDataAll as any).data.length/maxPage)

    // let i=setInterval(()=>{

    //   this.tableData = (this.tableDataAll as any).data.slice((num1++)*maxPage, (num++) * maxPage);
    //   console.log(this.tableData)
    //    this.$nextTick(() =>{
    // var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换，保证时间格式或者较长数字不会出现科学计数法。（这个很关键）
    // var wb = XLSX.utils.table_to_book(
    //   document.querySelector("#detailTable"),
    //   xlsxParam
    // );
    // /* 获取二进制字符串作为输出 */
    // var wbout = XLSX.write(wb, {
    //   bookType: "xlsx",
    //   bookSST: true,
    //   type: "array",
    // });
    // try {
    //   fileSaver?.saveAs(
    //     //Blob 对象表示一个不可变、原始数据的类文件对象。
    //     //Blob 表示的不一定是JavaScript原生格式的数据。
    //     //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
    //     //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
    //     new Blob([wbout], { type: "application/octet-stream" }),
    //     //设置导出文件名称
    //     this.tabType(item) +'['+num1+'页]'+ ".xlsx"
    //   );
    // } catch (e) {
    //   if (typeof console !== "undefined") console.log(e, wbout);
    // }
    //   form.size1=10
    // form.currentPage=1
    //  this.tableData = (this.tableDataAll as any).data.slice(0, 10);
    // return wbout;
    //   });
    //   if(num==(max+1)){
    //     clearInterval(i)
    //     this.tableLoding=false
    //   }
    // },1000)
    this.tableData = (this.tableDataAll as any).data;
    this.$nextTick(() => {
      var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换，保证时间格式或者较长数字不会出现科学计数法。（这个很关键）
      var wb = XLSX.utils.table_to_book(
        document.querySelectorAll(".testDetailTable")[item],
        xlsxParam
      );
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        fileSaver?.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          this.tabType(item) + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      form.size1 = 10;
      form.currentPage = 1;
      this.tableData = (this.tableDataAll as any).data?.slice(0, 10);
      this.tableLoding = false;
      return wbout;
    });
  }
}
